import { API } from "../connectBackend";



export const createTask = (todoId, userId, token, task) => {
    return fetch(`${API}/todo/task/create/${todoId}/${userId}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(task)
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




export const getTasks = (todoId, userId, token) => {
    return fetch(`${API}/todo/tasks/${todoId}/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}



//fetch tasks based on user
export const getTasksByUser = (userId, token) => {
    return fetch(`${API}/todo/user/tasks/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}




//delete todo
export const deleteTask = (todoId, taskId, userId, token) => {
    return fetch(`${API}/todo/task/${todoId}/${taskId}/${userId}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update task
export const editTask = (todoId, taskId, userId, token, task) => {
    return fetch(`${API}/todo/task/${todoId}/${taskId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(task)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update todo completion status
export const editTaskStatus = (todoId, taskId, userId, token, taskStatus) => {
    return fetch(`${API}/todo/task/status/${todoId}/${taskId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(taskStatus)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update task notification preference
export const editTaskNotificationPreference = (userId, token, isTaskNotificationsEnabled) => {
    return fetch(`${API}/todo/task/notifications/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(isTaskNotificationsEnabled)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




